module.exports = __webpack_public_path__ + "static/img/contact_logo5_h.37f1d5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact_logo5_h.png
// module id = dk7r
// module chunks = 1